import {type PropsWithChildren} from 'react'
import {tv, type VariantProps} from 'tailwind-variants'
import {gridItem} from '~/design-system/foundations'
import {type HgWYSIWYGType} from '../../types'

const unorderedListVariants = tv({
  base: 'list-outside ps-[1.25em] text-text-default [&_li_+_li]:mt-s2 [&_li_>_ul]:mt-s2',
  variants: {
    nestedLevel: {
      0: 'list-["⬩⠀"]',
      1: 'list-["▫⠀"]',
      2: 'list-["-⠀"]',
    },
    wysiwygType: {
      article: 'tiempos-body-2',
      legal: 'arcadia-body-2',
    },
  },
})

type UnorderedListNestedLevel = NonNullable<
  VariantProps<typeof unorderedListVariants>['nestedLevel']
>
export type UnorderedListProps = PropsWithChildren<{
  className?: string
  nestedLevel: UnorderedListNestedLevel
  wysiwygType: HgWYSIWYGType
}>

export const UnorderedList = ({
  children,
  className,
  nestedLevel,
  wysiwygType,
}: UnorderedListProps) => {
  return (
    <ul className={unorderedListVariants({nestedLevel, className, wysiwygType})}>
      {children}
    </ul>
  )
}

export const HgWYSIWYGUnorderedList = ({
  nestedLevel,
  className,
  ...props
}: UnorderedListProps) => {
  return (
    <UnorderedList
      {...props}
      nestedLevel={nestedLevel || 0}
      className={gridItem({size: 'heading', className})}
    />
  )
}
